import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./DevisEspace.css";
import axios from "axios";
import QR from "../../../../qr.png";
import CreateReclamationPopup from "../../../../components/CreateReclamationPopup";
import { formatCodeDevis } from "../../../../Services/CodeTrackingHelper";

const getStatusClass = (status: string): string => {
  if (status === "confirmé") return "status-confirme-dvu";
  if (status === "refusé")   return "status-refuse-dvu";
  return "status-en-cours-dvu";
};

const DevisEspace = () => {
  const [devisList, setDevisList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [Message, setMessage] = useState("");
  const [showSuccessPopup, setshowSuccessPopup] = useState(false);
  const [reclamationPopup, setReclamationPopup] = useState(false);
  const [reclamationRef, setReclamationRef] = useState("");
  const [claimedRefs, setClaimedRefs] = useState<Set<string>>(new Set());

  // Payment popup state
  const [paymentPopup, setPaymentPopup] = useState(false);
  const [selectedDevis, setSelectedDevis] = useState<any>(null);
  const [panierArticles, setPanierArticles] = useState<any[]>([]);
  const [panierLoading, setPanierLoading] = useState(false);
  const [payingLoading, setPayingLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState<"Par rib" | "Fatourati">("Par rib");
  const [payDone, setPayDone] = useState(false);

  const VisiteurId = localStorage.getItem("VisiteurId");

  const fetchDevis = async () => {
    try {
      const [devisRes, recRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/${VisiteurId}/devis`),
        VisiteurId
          ? axios.get(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/${VisiteurId}/reclamations`)
          : Promise.resolve({ data: [] })
      ]);
      setDevisList(devisRes.data);
      const refs = new Set<string>(
        (recRes.data as any[]).map((r: any) => r.RefCommande as string)
      );
      setClaimedRefs(refs);
    } catch (error) {
      console.error("Erreur lors du chargement des devis", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReclamationSuccess = (ref: string) => {
    setClaimedRefs((prev) => new Set(prev).add(ref));
  };

  useEffect(() => { fetchDevis(); }, []);

  const EnCours        = devisList.filter((d) => d.status === "en cours").length;
  const confirmedDevis = devisList.filter((d) => d.status === "confirmé").length;
  const refusedDevis   = devisList.filter((d) => d.status === "refusé").length;

  const showPopup = (msg: string) => {
    setMessage(msg);
    setshowSuccessPopup(true);
    setTimeout(() => setshowSuccessPopup(false), 3500);
  };

  const handleConfirmDevis = async (id: number) => {
    try {
      setLoading(true);
      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/visiteur/devis/${id}/confirmé`,
        { Url: process.env.REACT_APP_PHP_APP_URL }
      );
      showPopup("Vous avez confirmé votre devis");
      await fetchDevis();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleRefuseDevis = async (id: number) => {
    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/devis/${id}/refusé`);
      showPopup("Vous avez refusé votre devis");
      await fetchDevis();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleHoldDevis = async (id: number) => {
    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/devis/${id}/hold`);
      showPopup("Demande de disponibilité envoyée au magasin");
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // Open payment popup — group devis articles by DevisId
  const openPaymentPopup = (devis: any) => {
    setSelectedDevis(devis);
    setPayDone(false);
    setPaymentPopup(true);
    
    // Group all articles in this devis
    const items = devisList.filter((d) => 
      devis.DevisId ? d.DevisId === devis.DevisId : d.id === devis.id
    );
    setPanierArticles(items);
  };

  // Calculate devis total
  const devisTotal = panierArticles.reduce((sum: number, a: any) => {
    const price = parseFloat(a.prix || 0);
    const qty   = parseInt(a.qte || 1);
    return sum + price * qty;
  }, 0);

  // Confirm payment
  const handlePayer = async () => {
    if (!selectedDevis) return;
    try {
      setPayingLoading(true);
      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/visiteur/devis/${selectedDevis.id}/payer`
      );
      // Optimistic update for all devis items under same DevisId
      setDevisList((prev) =>
        prev.map((d) =>
          (selectedDevis.DevisId && d.DevisId === selectedDevis.DevisId) || d.id === selectedDevis.id
            ? { ...d, status_payment: "payé" }
            : d
        )
      );
      setPayDone(true);
    } catch (err) {
      console.error(err);
    } finally {
      setPayingLoading(false);
    }
  };

  const closePaymentPopup = () => {
    setPaymentPopup(false);
    setSelectedDevis(null);
    setPayDone(false);
  };

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const GoBack = () => window.history.back();

  /* ─── PAYMENT POPUP ─────────────────────────────── */
  const PaymentModal = () =>
    paymentPopup && selectedDevis ? (
      <div
        style={{
          position: "fixed", inset: 0, zIndex: 9999,
          background: "rgba(15,23,42,0.6)", backdropFilter: "blur(5px)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "12px", overflowY: "auto",
        }}
        onClick={closePaymentPopup}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "#fff", borderRadius: 20,
            width: "100%", maxWidth: 620,
            boxShadow: "0 32px 80px rgba(0,0,0,0.25)",
            overflow: "hidden", position: "relative",
            maxHeight: "92vh", overflowY: "auto",
          }}
        >
          {/* ── Header ── */}
          <div style={{
            background: "linear-gradient(135deg,#1e293b,#0f172a)",
            padding: "20px 24px", display: "flex",
            justifyContent: "space-between", alignItems: "center",
            position: "sticky", top: 0, zIndex: 10,
          }}>
            <div>
              <h2 style={{ margin: 0, color: "#fff", fontSize: "1.05rem", fontWeight: 700, fontFamily: "Lato" }}>
                Choisir le mode de paiement
              </h2>
              <p style={{ margin: "3px 0 0", color: "#94a3b8", fontSize: "0.75rem", fontFamily: "Lato" }}>
                Devis #{selectedDevis.id} — {selectedDevis.MagasinName}
              </p>
            </div>
            <button
              onClick={closePaymentPopup}
              style={{
                background: "rgba(255,255,255,0.12)", border: "none", color: "#fff",
                width: 34, height: 34, borderRadius: "50%", cursor: "pointer",
                fontSize: "1rem", display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              <i className="bi bi-x-lg" />
            </button>
          </div>

          {panierLoading || payingLoading ? (
            <div style={{ textAlign: "center", padding: "48px 0" }}>
              <div className="custom-spinner-dvu" role="status" style={{ margin: "0 auto 12px" }} />
              <p style={{ color: "#64748b", fontFamily: "Lato" }}>
                {payingLoading ? "Paiement en cours..." : "Chargement…"}
              </p>
            </div>
          ) : payDone ? (
            /* ── Success screen ── */
            <div style={{ textAlign: "center", padding: "0 0 32px" }}>
              <div style={{
                background: "linear-gradient(135deg,#22c55e,#16a34a)",
                height: 120, display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <div style={{
                  width: 64, height: 64, background: "#fff", borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 30, color: "#22c55e", fontWeight: 700,
                }}>✓</div>
              </div>
              <div style={{ padding: "24px 28px" }}>
                <h2 style={{ fontFamily: "Lato", fontWeight: 700, margin: "0 0 8px" }}>Merci pour votre paiement !</h2>
                <p style={{ color: "#64748b", fontFamily: "Lato", fontSize: "0.9rem", marginBottom: 20 }}>
                  Veuillez envoyer le reçu à l'adresse ci-dessous
                </p>
                <div style={{ background: "#f6f8fa", borderRadius: 12, padding: 12, marginBottom: 20 }}>
                  <div style={{
                    display: "flex", alignItems: "center", background: "#fff",
                    borderRadius: 10, padding: "10px 12px",
                  }}>
                    <div style={{
                      width: 36, height: 36, borderRadius: 8, display: "flex",
                      alignItems: "center", justifyContent: "center",
                      background: "#e9f7ef", color: "#22c55e", fontWeight: 700,
                      marginRight: 10, flexShrink: 0,
                    }}>✉</div>
                    <div style={{ textAlign: "left" }}>
                      <span style={{ display: "block", fontSize: "0.7rem", color: "#999", fontFamily: "Lato" }}>EMAIL</span>
                      <span style={{ fontSize: "0.88rem", fontWeight: 500, fontFamily: "Lato" }}>wyncontact.ma@gmail.com</span>
                    </div>
                  </div>
                </div>
                <button
                  onClick={closePaymentPopup}
                  style={{
                    width: "100%", background: "linear-gradient(135deg,#22c55e,#16a34a)",
                    color: "#fff", border: "none", padding: "14px", borderRadius: 12,
                    fontSize: "0.95rem", fontWeight: 600, cursor: "pointer", fontFamily: "Lato",
                  }}
                >
                  Compris, merci !
                </button>
              </div>
            </div>
          ) : (
            <div style={{ padding: "20px 24px 24px" }}>

              {/* ── Articles du panier ── */}
              {panierArticles.length > 0 && (
                <div style={{ marginBottom: 20 }}>
                  <h4 style={{ margin: "0 0 10px", fontSize: "0.78rem", color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8, fontFamily: "Lato" }}>
                    Articles commandés
                  </h4>
                  <div style={{ border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden" }}>
                    {panierArticles.map((art: any, i: number) => {
                      const prix = parseFloat(art.Prix || art.prix || 0);
                      const qte  = parseInt(art.Quantite || art.qte || 1);
                      return (
                        <div key={i} style={{
                          display: "flex", justifyContent: "space-between", alignItems: "center",
                          padding: "11px 16px",
                          borderBottom: i < panierArticles.length - 1 ? "1px solid #f1f5f9" : "none",
                          background: i % 2 === 0 ? "#fff" : "#fafbfc",
                        }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{
                              width: 34, height: 34, background: "#f1f5f9", borderRadius: 8,
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: "1rem", color: "#64748b",
                            }}>
                              <i className="bi bi-box-seam" />
                            </div>
                            <div>
                              <p style={{ margin: 0, fontWeight: 600, fontSize: "0.85rem", color: "#1e293b", fontFamily: "Lato" }}>
                                {art.Designation || art.NomArticle || art.designation || "Article"}
                              </p>
                              <span style={{ fontSize: "0.72rem", color: "#94a3b8", fontFamily: "Lato" }}>
                                Qté : {qte} × {prix.toFixed(2)} MAD
                              </span>
                            </div>
                          </div>
                          <span style={{
                            fontWeight: 700, fontSize: "0.88rem", color: "#1e293b",
                            background: "#f1f5f9", borderRadius: 8, padding: "3px 12px", fontFamily: "Lato",
                          }}>
                            {(prix * qte).toFixed(2)} MAD
                          </span>
                        </div>
                      );
                    })}
                    {/* Total row */}
                    <div style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      padding: "12px 16px",
                      background: "linear-gradient(135deg,#f0fdf4,#dcfce7)",
                      borderTop: "2px solid #86efac",
                    }}>
                      <span style={{ fontWeight: 700, color: "#166534", fontFamily: "Lato" }}>Total</span>
                      <span style={{ fontWeight: 800, fontSize: "1.05rem", color: "#15803d", fontFamily: "Lato" }}>
                        {devisTotal.toFixed(2)} MAD
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* ── Payment method: Virement Bancaire ── */}
              <div
                className={`payment-option ${paymentMethod === "Par rib" ? "active" : ""}`}
                onClick={() => setPaymentMethod("Par rib")}
                style={{ cursor: "pointer" }}
              >
                <div className="option-header">
                  <div className="icon" style={{ fontSize: 26, marginRight: 12 }}>
                    <i className="bi bi-bank" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ margin: 0, fontFamily: "Lato", fontSize: 17 }}>Virement Bancaire</h3>
                    <span style={{ color: "#888", fontSize: 13, fontFamily: "Lato" }}>Paiement par RIB avec QR code</span>
                  </div>
                  <input type="radio" checked={paymentMethod === "Par rib"} readOnly />
                </div>

                {paymentMethod === "Par rib" && (
                  <div className="option-body">
                    <div className="bank-left">
                      <div className="qr-placeholder">
                        <img src={QR} alt="QR Paiement" />
                      </div>
                      <p style={{ fontFamily: "Lato", fontSize: "0.82rem" }}>Scannez pour payer via Banque</p>
                      <p className="rib-mask" style={{ fontFamily: "Lato" }}>RIB: **** **** **65 77</p>
                    </div>
                    <div className="bank-right">
                      <p style={{ fontFamily: "Lato" }}><b>Banque:</b> Banque Populaire</p>
                      <p style={{ fontFamily: "Lato" }}><b>RIB:</b> 007 780 0003102000302865 77</p>
                    </div>
                  </div>
                )}
              </div>

              {/* ── Security note ── */}
              <p style={{
                textAlign: "center", fontSize: "0.78rem", color: "#6c6c6c",
                fontFamily: "Lato", margin: "10px 0 16px",
              }}>
                🔒 Tous les paiements sont sécurisés et cryptés
              </p>

              {/* ── Confirm button ── */}
              <button
                onClick={handlePayer}
                disabled={payingLoading}
                className="download-btn"
                style={{
                  background: payingLoading
                    ? "#94a3b8"
                    : "linear-gradient(135deg,#22c55e,#16a34a)",
                  cursor: payingLoading ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                }}
              >
                {payingLoading ? (
                  <>
                    <div className="custom-spinner-dvu" role="status" style={{ width: 18, height: 18 }} />
                    Traitement…
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle-fill" /> Terminer
                  </>
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    ) : null;

  /* ─── MOBILE VIEW ────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
        <div className="mobile-page-header-dvu">
          <h3>Historique des Devis</h3>
          <h6>Consultez l'historique complet de vos devis et leur statut.</h6>
        </div>

        <div className="mobile-card-container-dvu">
          {devisList.length > 0 ? (
            devisList.map((item, index) => (
              <div key={index} className="mobile-card-dvu">
                <div className="mobile-card-header-dvu">
                  <span className="mobile-card-id-dvu">{formatCodeDevis(item.RefDevis, item.id, item.date)}</span>
                  <span className={`mobile-card-status-dvu ${getStatusClass(item.status)}`}>
                    {item.status}
                  </span>
                </div>

                <div className="mobile-card-content-dvu">
                  <div className="mobile-card-row-dvu">
                    <span className="mobile-card-label-dvu">Magasin</span>
                    <span className="mobile-card-value-dvu">{item.MagasinName}</span>
                  </div>
                  <div className="mobile-card-row-dvu">
                    <span className="mobile-card-label-dvu">Total</span>
                    <span className="mobile-card-value-dvu">{item.prix} MAD</span>
                  </div>
                  <div className="mobile-card-row-dvu">
                    <span className="mobile-card-label-dvu">Date</span>
                    <span className="mobile-card-value-dvu">{item.date}</span>
                  </div>

                  <div className="mobile-card-row-dvu">
                    <span className="mobile-card-label-dvu">Paiement</span>
                    {item.status_payment === "payé" ? (
                      <span style={{
                        background: "linear-gradient(135deg,#22c55e,#16a34a)",
                        color: "#fff", borderRadius: 99, padding: "3px 10px",
                        fontSize: "0.75rem", fontWeight: 800,
                      }}>
                        ✓ Payé
                      </span>
                    ) : (
                      <button
                        onClick={() => openPaymentPopup(item)}
                        style={{
                          background: "linear-gradient(135deg,#ef4444,#dc2626)",
                          color: "#fff", border: "none", borderRadius: 8,
                          padding: "4px 10px", fontSize: "0.75rem", fontWeight: 700,
                          cursor: "pointer", display: "flex", alignItems: "center", gap: 4,
                        }}
                      >
                        <i className="bi bi-credit-card" /> Pas payé
                      </button>
                    )}
                  </div>

                  {item.status !== "confirmé" && item.status !== "refusé" && (
                    <div className="mobile-card-row-dvu">
                      <span className="mobile-card-label-dvu">Action</span>
                      <div className="mobile-action-icons-dvu">
                        <button className="mobile-confirm-icon-dvu" onClick={() => handleConfirmDevis(item.id)}>
                          <i className="bi bi-check2-square" />
                        </button>
                        <button className="mobile-refuse-icon-dvu" onClick={() => handleRefuseDevis(item.id)}>
                          <i className="bi bi-trash3" />
                        </button>
                        <button
                          style={{ color: "#f39c12", background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer", marginLeft: 10 }}
                          onClick={() => handleHoldDevis(item.id)}
                          title="Demander la disponibilité"
                        >
                          <i className="bi bi-arrow-repeat" />
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="mobile-card-row-dvu">
                    <span className="mobile-card-label-dvu">Réclamation</span>
                    {claimedRefs.has(`DEV-${item.id}`) ? (
                      <span
                        style={{
                          color: "#6b7280",
                          fontSize: "0.85rem",
                          fontWeight: 700,
                          display: "flex",
                          alignItems: "center",
                          gap: 4
                        }}
                      >
                        <i className="bi bi-shield-check" /> Réclamé
                      </span>
                    ) : (
                      <button
                        style={{ color: "#ef4444", background: "none", border: "none", fontSize: "0.85rem", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}
                        onClick={() => {
                          setReclamationRef(`DEV-${item.id}`);
                          setReclamationPopup(true);
                        }}
                      >
                        <i className="bi bi-shield-exclamation" /> Réclamer
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="mobile-empty-dvu">
              <i className="bi bi-inbox" />
              <p>Aucun devis</p>
            </div>
          )}
        </div>

        {showSuccessPopup && (
          <div className="popup-success-dvu">
            <div className="popup-content-dvu">
              <div className="popup-icon-dvu"><i className="bi bi-check-circle-fill" /></div>
              <h5>Félicitations !</h5>
              <p>{Message}</p>
            </div>
          </div>
        )}
        <PaymentModal />
      </>
    );
  }

  /* ─── DESKTOP VIEW ───────────────────────────── */
  return (
    <div className="dashboard-visiteurinter-dvu">
      {loading ? (
        <div className="loader-wrapper-dvu">
          <div className="custom-spinner-dvu" role="status" />
          <span className="loader-charg-dvu">Chargement</span>
        </div>
      ) : (
        <div className="main-visiteurinter-dvu">
          <button onClick={GoBack} className="back-button-visiteurinter-dvu">
            <i className="bi bi-arrow-left-circle" /> Retour
          </button>

          <h2 className="welcome-visiteurinter-dvu">Gestion des devis</h2>
          <p className="subtitle-visiteurinter-dvu">Suivez et gérez vos devis en temps réel.</p>

          {/* Stat cards */}
          <div className="cards-container-visiteurinter-dvu">
            <div className="card-visiteurinter-dvu pending-dvu">
              <h4>Devis en cours</h4>
              <p className="card-number-visiteurinter-dvu">{EnCours}<i className="bi bi-clock-history iconE-dvu" /></p>
              <span>Total de devis en cours</span>
            </div>
            <div className="card-visiteurinter-dvu confirmed-dvu">
              <h4>Devis confirmés</h4>
              <p className="card-number-visiteurinter-dvu">{confirmedDevis}<i className="bi bi-check2-circle iconC-dvu" /></p>
              <span>Devis que vous avez confirmés</span>
            </div>
            <div className="card-visiteurinter-dvu cancelled-dvu">
              <h4>Devis Refusés</h4>
              <p className="card-number-visiteurinter-dvu">{refusedDevis}<i className="bi bi-x-circle iconA-dvu" /></p>
              <span>Devis que vous avez refusés</span>
            </div>
          </div>

          {/* Table */}
          <div className="devis-section-visiteurinter-dvu">
            <div className="devis-header-visiteurinter-dvu">
              <h3>Liste des devis</h3>
            </div>
            <table className="devis-table-visiteurinter-dvu">
              <thead>
                <tr>
                  <th>Code Devis</th>
                  <th>Magasin</th>
                  <th>Référence</th>
                  <th>Désignation</th>
                  <th>Prix</th>
                  <th>Quantité</th>
                  <th>Statut</th>
                  <th>Paiement</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {devisList.map((devis, index) => (
                  <tr key={index}>
                    <td><strong style={{ fontFamily: "monospace", color: "#2563eb" }}>{formatCodeDevis(devis.RefDevis, devis.id, devis.date)}</strong></td>
                    <td>{devis.MagasinName}</td>
                    <td>{devis.RefArticle}</td>
                    <td>{devis.designation}</td>
                    <td><strong>{devis.prix?.split("T")[0]} MAD</strong></td>
                    <td>
                      <div className="qty-cell-dvu">
                        {devis.qte}<i className="bi bi-box-seam" />
                      </div>
                    </td>
                    <td>
                      <span className={`status-badge-dvu ${getStatusClass(devis.status)}`}>
                        {devis.status}
                      </span>
                    </td>
                    <td>
                      {devis.status_payment === "payé" ? (
                        <span style={{
                          background: "linear-gradient(135deg,#22c55e,#16a34a)",
                          color: "#fff", borderRadius: 99, padding: "4px 12px",
                          fontSize: "0.78rem", fontWeight: 800, whiteSpace: "nowrap",
                          display: "inline-flex", alignItems: "center", gap: 5,
                        }}>
                          <i className="bi bi-check-circle-fill" /> Payé
                        </span>
                      ) : (
                        <button
                          onClick={() => openPaymentPopup(devis)}
                          style={{
                            background: "linear-gradient(135deg,#ef4444,#dc2626)",
                            color: "#fff", border: "none", borderRadius: 8,
                            padding: "5px 12px", fontSize: "0.78rem", fontWeight: 700,
                            cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 5,
                            whiteSpace: "nowrap", boxShadow: "0 2px 8px rgba(239,68,68,0.3)",
                          }}
                        >
                          <i className="bi bi-credit-card" /> Pas payé
                        </button>
                      )}
                    </td>
                    <td>
                      <div className="date-cell-dvu">
                        <i className="bi bi-calendar-week" />
                        {new Date(devis.date).toLocaleDateString("fr-FR")}
                      </div>
                    </td>
                    <td>
                      <div className="actions-cell-visiteurinter-dvu" style={{ display: "flex", alignItems: "center" }}>
                        {devis.status !== "confirmé" && devis.status !== "refusé" && (
                          <>
                            <button className="btn-confirm-dvu" title="Confirmer" onClick={() => handleConfirmDevis(devis.id)}>
                              <i className="bi bi-check-circle" />
                            </button>
                            <button className="btn-refuse-dvu" title="Refuser" onClick={() => handleRefuseDevis(devis.id)}>
                              <i className="bi bi-x-circle" />
                            </button>
                            <button
                              title="Demander la disponibilité"
                              style={{ color: "#f39c12", background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer", marginLeft: 8 }}
                              onClick={() => handleHoldDevis(devis.id)}
                            >
                              <i className="bi bi-arrow-repeat" />
                            </button>
                          </>
                        )}
                        {claimedRefs.has(`DEV-${devis.id}`) ? (
                          <span
                            title="Déjà réclamé"
                            style={{ color: "#6b7280", fontSize: "1rem", fontWeight: 700, marginLeft: 8, display: "inline-flex", alignItems: "center" }}
                          >
                            <i className="bi bi-shield-check" />
                          </span>
                        ) : (
                          <button
                            title="Réclamation"
                            style={{ color: "#ef4444", background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer", marginLeft: 8 }}
                            onClick={() => {
                              setReclamationRef(`DEV-${devis.id}`);
                              setReclamationPopup(true);
                            }}
                          >
                            <i className="bi bi-shield-exclamation" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {showSuccessPopup && (
            <div className="popup-success-dvu">
              <div className="popup-content-dvu">
                <div className="popup-icon-dvu"><i className="bi bi-check-circle-fill" /></div>
                <h5>Félicitations !</h5>
                <p>{Message}</p>
              </div>
            </div>
          )}
        </div>
      )}

      <PaymentModal />
      <CreateReclamationPopup
        isOpen={reclamationPopup}
        onClose={() => setReclamationPopup(false)}
        refId={reclamationRef}
        type="devis"
        onSuccess={handleReclamationSuccess}
      />
    </div>
  );
};

export default DevisEspace;